export const formatEnumString = (val?: string | null, fallback = '—'): string => {
  if (!val || typeof val !== 'string' || !val.trim()) return fallback;
  return val
    .replace(/_/g, ' ')
    .replace(/-/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .trim();
};

export const toTitleCase = (value: string): string => {
  return value.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase());
};

export const capitalizeFirst = (value: string): string => {
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};
